export default {
      id: "sli-dots-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.b3fb107f.svg#sli-dots",
      toString: function () {
        return this.url;
      }
    }